import React from "react";
import Panel from "common/components/Panel";
import actions from "./actions";
import FormFoodOrderingManagement from "./FormFoodOrderingManagement";

async function handleSubmit(values, form) {
  const { name, url } = values;
  const { setSubmitting, setErrors, setStatus, resetForm } = form;
  try {
    await actions.create({ name, url });
    resetForm();
    setStatus({ success: true });
  } catch (e) {
    setErrors({ http: e.message });
  }
  setSubmitting(false);
}

const initialValues = {
  name: "",
};

const CreateCategory = () => (
  <Panel title="Create Provider">
    <FormFoodOrderingManagement
      handleSubmit={handleSubmit}
      initialValues={initialValues}
    />
  </Panel>
);

export default CreateCategory;
